import { connect } from 'react-redux';
import ReportAccountStatementByDayComponent from './account-statement-by-day.component';

function mapStateToProps({}: any): any {
	return {};
}

function mapDispatchToProps(): any {
	return {
		intl: null,
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportAccountStatementByDayComponent);



// WEBPACK FOOTER //
// ./src/components/report/account-statement-by-day/account-statement-by-day.ts